import {AccountQL} from '../graphql/AccountQL';
import {AccountType} from './AccountType';

export type AccountId = number;

export default class Account {
  readonly id: AccountId;
  readonly name: string;
  readonly image?: string;
  readonly accountType: AccountType;

  constructor(data: AccountQL) {
    this.id = data.id;
    this.name = data.name;
    this.image = data.image;
    this.accountType = Account.mapAccountType(data.__typename);
  }

  isAdmin() {
    return this.accountType === AccountType.Admin;
  }

  isBrand() {
    return this.accountType === AccountType.Brand;
  }

  isTrainer() {
    return this.accountType === AccountType.Trainer;
  }

  isCompany() {
    return this.accountType === AccountType.Company;
  }

  readableType() {
    switch (this.accountType) {
      case AccountType.Brand:
        return 'Brand';
      case AccountType.Company:
        return 'Company';
      case AccountType.Admin:
        return 'Admin';
      default:
        return 'Trainer';
    }
  }

  protected static mapAccountType(typename: string): AccountType {
    switch (typename) {
      case 'Brand':
        return AccountType.Brand;
      case 'CompanyAccount':
        return AccountType.Company;
      case 'Admin':
        return AccountType.Admin;
      default:
        return AccountType.Trainer
    }
  }
}
